import React, { FC, memo } from 'react';
import { Container, Line } from './styles';

const SignOff: FC = () => (
  <Container>
    <Line>All the best,</Line>
    <Line>Simon &amp; the SWD team</Line>
  </Container>
);

export default memo(SignOff);
